import { newId } from '@/lib/id';
import { nowIsoSec } from '@/lib/date';

export type ActType = 'a' | 'v';

export type Act = {
  id: string;
  type: ActType;
  name: string;
  code: string;
  modifier: string;
  units: string;
  billedAt: string;
  userId: string;
  patientId: string;
  amount: string;
  rawAmount: string;
  refMdName: string;
  refMdNo: string;
  shiftId: string;
  eventDate: string;
  lesionSide: string;
};

function s(v: unknown, fb = ''): string {
  return v == null ? fb : String(v);
}

export function actFromDoc(id: string, data: Record<string, unknown>): Act {
  return {
    id,
    type: s(data.type, 'a') as ActType,
    name: s(data.name),
    code: s(data.code),
    modifier: s(data.modifier),
    units: s(data.units),
    billedAt: s(data.billedAt),
    userId: s(data.userId),
    patientId: s(data.patientId),
    amount: s(data.amount, '0'),
    rawAmount: s(data.rawAmount, '0'),
    refMdName: s(data.refMdName),
    refMdNo: s(data.refMdNo),
    shiftId: s(data.shiftId, 'current_shift'),
    eventDate: s(data.eventDate),
    lesionSide: s(data.lesionSide),
  };
}

export function actToMap(a: Act): Record<string, unknown> {
  const { id: _id, ...rest } = a;
  return rest;
}

export function newAct(args: {
  type: ActType;
  name: string;
  code: string;
  modifier?: string;
  units?: string;
  amount: string;
  rawAmount: string;
  userId: string;
  patientId: string;
  refMdName?: string;
  refMdNo?: string;
  eventDate?: string;
  lesionSide?: string;
}): Act {
  return {
    id: newId(),
    type: args.type,
    name: args.name,
    code: args.code,
    modifier: args.modifier ?? '',
    units: args.units ?? '',
    billedAt: nowIsoSec(),
    userId: args.userId,
    patientId: args.patientId,
    amount: args.amount,
    rawAmount: args.rawAmount,
    refMdName: args.refMdName ?? '',
    refMdNo: args.refMdNo ?? '',
    shiftId: 'current_shift',
    eventDate: args.eventDate ?? '',
    lesionSide: args.lesionSide ?? '',
  };
}
